import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Swal from 'sweetalert2';

import { useLoading } from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css';
import { reactive, computed } from 'vue';
export function shared() {
    const router = useRouter();
    const store = useStore();
    const authUser = computed(() => store.state.admin.auth.authUser);


    const isSuperAdmin = computed(() => authUser.value.roles ? authUser.value.roles[0].name == 'super_admin' : false);
    const isAdmin = computed(() => authUser.value.roles ? authUser.value.roles[0].name == 'admin' : false);
    const isSubscriber = computed(() => authUser.value.roles ? authUser.value.roles[0].name == 'subscriber' : false);
    const isSeller = computed(() => authUser.value.roles ? authUser.value.roles[0].name == 'seller' : false);
    const isDelegate = computed(() => authUser.value.roles ? authUser.value.roles[0].name == 'delegate' : false);
    const isAccountant = computed(() => authUser.value.roles ? authUser.value.roles[0].name == 'accountant' : false);


    const $loading = useLoading({
        // options
    });




    const ORDER_STATUS = reactive({
        DRAFT: 1,
        WAITING: 2,
        IN_REVIEW: 3,
        BUY_ORDER: 4,
        DELIVERY: 5,
        SHIPPED: 6,
        PACKAGING: 7,
        COLLECTION_POINT: 8,
        DELIVERY_SAFE: 9,
        HAS_BEEN_REVIEWED: 10,
        PRE_PAYMENT: 11,
        INTERNAL_SHIPPING: 12,
        COLLECTION_CENTER: 13
    });
    const RECHARGE_CARD_STATUS = reactive({
        INACTIVE: 1,
        ACTIVE: 2,
        ASSIGNED_TO_DELEGATE: 3,
        RECEIVED_FROM_DELEGATE: 4,
        RECEIVED_FROM_POINT_OF_SALE: 5,
        REJECTED_FROM_POINT_OF_SALE: 6,
        HAS_BEEN_SOLD: 7,
        HAS_BEEN_SOLD_AND_MONEY_RECEIVED: 8,
        USED: 9,
    });

    let loader = null;
    const showLoader = () => {
        loader = $loading.show({
            // Optional parameters
        });
    }
    const hideLoader = () => {
        if (loader) {
            loader.hide();
            loader = null;
        }
    }

    const mixinShowAlert = (message, icon, type, redirect_to = null, params = {}, query = {}) => {
        Swal.fire({
            title: 'معلومات',
            text: message,
            icon: icon,
            type: type,
            confirmButtonText: 'موافق',
            confirmButtonColor: '#dc661e',
        }).then(() => {
            if (redirect_to)
                router.push({ name: redirect_to, params: params, query: query });
        });
    }

    const mixinConfirmAlert = (dispatch_delete, dispatch_fetch, id, filter) => {
        let answer = Swal.fire({
                icon: 'warning',
                title: "هل انت متأكد ؟",
                text: "سيتم حذف هذا السجل",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "نعم انا متأكد !",
                cancelButtonText: "لا, رجوع !",
                closeOnConfirm: false,
                closeOnCancel: false
            })
            .then((result) => {
                if (result.value) {
                    showLoader();
                    store.dispatch(dispatch_delete, id).then((Response) => {
                        hideLoader();
                        Swal.fire({
                            title: 'معلومات',
                            text: 'تم الحذف بنجاح',
                            icon: 'success',
                            type: 'success',
                            confirmButtonText: 'موافق',
                        }).then(() => {
                            if (dispatch_fetch) {
                                showLoader();
                                store.dispatch(dispatch_fetch, filter).then(() => {
                                    hideLoader();
                                }).catch(() => {
                                    hideLoader();
                                });
                            } else {
                                hideLoader();
                            }
                        });
                    }).catch(() => {
                        hideLoader();
                    })
                }
            });
    }

    return {
        mixinShowAlert,
        mixinConfirmAlert,
        showLoader,
        hideLoader,
        ORDER_STATUS,
        RECHARGE_CARD_STATUS,
        isSuperAdmin,
        isAdmin,
        isSubscriber,
        isSeller,
        isDelegate,
        isAccountant
    }
}